/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminProjectsControllerDeleteTeamMemberV1$Params {
  projectId: string;
  memberId: string;
}

export function adminProjectsControllerDeleteTeamMemberV1(http: HttpClient, rootUrl: string, params: AdminProjectsControllerDeleteTeamMemberV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'memberId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminProjectsControllerDeleteTeamMemberV1.PATH, 'delete');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('memberId', params.memberId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'memberId'?: string;
      }>;
    })
  );
}

adminProjectsControllerDeleteTeamMemberV1.PATH = '/v1/admin/projects/{projectId}/team-members/{memberId}';
